import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { _HttpServices } from "../../../_services/_HttpServices";
import ReactTable from "../../../components/FilterTable";
import { Button } from "react-bootstrap";
import { IoMdCreate, IoIosAdd, IoMdDownload,IoMdTrash,IoMdDoneAll,IoIosClose } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { Toast,Modal } from "react-bootstrap";
// Local imports
import Loader from "../../../components/Loader";
import moment from 'moment'
import getExcel from "../../../_services/ExcelUtility";

const Customer = ({ dispatch, login }) => {
  const fileName = 'Price Update';
  const history = useHistory();
  const [drugPriceList, setDrugPriceList] = useState([]);
  const [showToaster, setShowToaster] = useState(false);
  // const [userUpdated, setUserUpdated] = useState(false);
  const [holidayDelete, setHolidayDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loggedInUserData, setLoggedInUserData] = useState({});
  const [hasError, setHasError] = useState(false);
  const [showCancelToaster, setCancelShowToaster] = useState(false);
  const [errorToaster, setErrorToaster] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [errorMessage, setErrorMessage] = useState();
  
  useEffect(() => {
    getCustmerPriceDetails();
    if (localStorage.getItem("userData")) {
      setLoggedInUserData(JSON.parse(localStorage.getItem("userData")));
    }
  }, []);
  const getCustmerPriceDetails = async () => {
      setLoading(true)
      await _HttpServices
      .getData(`Api/Product/GetCustomerAccount`)
      .then((response) => {
        if (response.data) {
          let drugPriceDetailsList = response.data;
          if(drugPriceDetailsList.length > 0){
          drugPriceDetailsList.map(res => {
            res.CreatedOn = moment(res.CreatedOn).format('MM/DD/YYYY');
            res.Active = res.Active? "Active" : "InActive";
          })
        }
          setDrugPriceList(drugPriceDetailsList);
          setLoading(false)
        }
      })
      .catch((e) => {
        console.log(e);
        setHasError(true)
        setLoading(false);
      });
  };
  
 const columns = [
    {
      Header: "Actions",
      accessor: "accessor",
      disableFilters: true,
      disableSortBy: true,
      width: 80,
      // Cell: ({ row: { original } }) => (
      //   <Fragment>
      //     {loggedInUserData.RoleID !== 2 && (
      //       <Button
      //         variant="link"
      //         title="Delete Holiday"
      //         // onClick={() =>deleteHoliday(original.HolidayID)}
      //         className="grid-action-btn"
      //       >
      //         <IoMdTrash className="icon" />
      //       </Button>
      //     )}
      //   </Fragment>
      // ),
    },
      {
        Header: "Customer Number Account ID",
        accessor: "CustomerNumberAccountID",
        filter: "CustomerNumberAccountID",
        sortType: "basic",
        width:200
      },
      {
        Header: "HMID",
        accessor: "HMID",
        filter: "HMID",
        sortType: "basic",
      },
      {
        Header: "Entity Name",
        accessor: "EntityName",
        filter: "EntityName",
        sortType: "basic",
        width:250,
      },
      {
        Header: "Entity Code",
        accessor: "EntityCode",
        filter: "EntityCode",
        sortType: "basic",
      },
      {
        Header: "Invoice Delivery Method",
        accessor: "InvoiceDeliveryMethod",
        filter: "InvoiceDeliveryMethod",
        sortType: "basic",
        width:250,
      },
      {
        Header: "User",
        accessor: "CreatedBy",
        filter: "CreatedBy",
        sortType: "basic",
      },
      {
        Header: "Effective Date",
        accessor: "CreatedOn",
        filter: "CreatedOn",
        sortType: "basic",
      }
    ];
  
  const onFileChange = event => { 
      setSelectedFile(event.target.files[0]);
  }; 

  const onFileCancel = event => {
    setSelectedFile("")
  }
  const onFileUpload = () => { 
     
      // Create an object of formData 
      if(selectedFile){
        // if(selectedFile.type === 'xls' || selectedFile.type === 'xlsx' || selectedFile.type === 'xlsm' || selectedFile.type === 'xlsb'){

            const formData = new FormData(); 
     
            // Update the formData object 
            formData.append( 
              "myFile", 
              selectedFile, 
              selectedFile.name 
            ); 

            setLoading(true);

            _HttpServices
            .postData("Api/Product/ImportCustomerAccounts", formData)
            .then((data) => {
                if (data.data === "") {
                  getCustmerPriceDetails();
                    setLoading(false);
                    setShowToaster(true);
                    setErrorToaster(false);
                    setErrorMessage("File uploaded successfully")
                }
            })
            .catch((e) => {
                setLoading(false);
                console.log(e.response.data.Message);
                setShowToaster(true);
                setErrorToaster(true);
                setErrorMessage(e.response.data.Message)
            });
           
            // Details of the uploaded file 
            // console.log(this.state.selectedFile); 
           
            // Request made to the backend api 
            // Send formData object 
          //   axios.post("api/uploadfile", formData); 
        // }else {
        //     setShowToaster(true);
        //     setErrorToaster(true);
        // }
      }
    }; 
  return (
      <div>
      {/* Toaster */}
      <Toast className={errorToaster ? "err-toaster" : "custom-toaster"}
        onClose={() => setShowToaster(false)}
        show={showToaster}
        delay={2500}
        autohide
        className="custom-toaster"
      >
        {/* {holidayDelete && <Toast.Body>Price Update sheet updated successfully</Toast.Body>} */}
        {/* {errorToaster && <Toast.Body>Allowed only xls or xlsx files </Toast.Body>} */}
        <Toast.Body>{errorMessage}</Toast.Body>
      </Toast>
      <div>
        <div className="card-body"> 
            <input type="file" onChange={onFileChange} /> 
            
            <Button type="submit" onClick={onFileUpload}> 
                Upload
            </Button> 
            {/* <Button type="reset" > 
                Cancel
            </Button>  */}
            
        </div> 
      </div>
      <div className="users-grid-wrap">
        <div className="card pt-3">
          <div className="card-body">
          
               <ReactTable columns={columns} data={drugPriceList} defaultPageSize={10} />  
           
          </div>
        </div>
      </div>
      {loading ? <Loader /> : null}

    </div>
  );
};


// Map Redux state to React component props
const mapStateToProps = (state) => ({
  loading: state.users.loading,
  login: state.users.login,
  users: state.users.users,
  hasErrors: state.users.hasErrors,
});

// Connect Redux to React
export default connect(mapStateToProps)(Customer);
